import React from "react";
import useCurrency from "../../../../../hooks/useCurrency";

import {

    Alert,
    Button,
    Space,
    Typography

} from "antd";

const { Text } = Typography;

const AgreementFooter = ({

                             offer,

                             canAccept,

                             loading,

                             onAccept,

                             onDecline

                         }) => {

    const { symbol } = useCurrency();

    if (!offer) {

        return null;

    }

    console.log("The offer in AgreementFooter", offer)

    return (

        <div
            style={{
                padding:20,
                background:"#fff"
            }}
        >

            <Alert

                type="info"

                showIcon

                message="Le vendeur vous a envoyé une offre commerciale."

                description={

                    <>

                        <div
                            style={{
                                marginTop:16,
                                marginBottom:20
                            }}
                        >

                            <Text>

                                Prix proposé :

                                {" "}

                                <b>

                                    {

                                        offer.negotiatedUnitPrice

                                    }

                                    {" "}
                                    {symbol(offer.currency)}

                                </b>

                            </Text>

                            <br/>

                            <Text>

                                Kg / paquet :

                                {" "}

                                {

                                    offer.negotiatedPacketQuantity

                                }

                            </Text>

                            <br/>

                            <Text>

                                Disponibilité :

                                {" "}

                                {

                                    offer.negotiatedAvailablePackets

                                }

                                {" "}
                                paquets

                            </Text>

                        </div>

                        <Space>

                            <Button

                                type="primary"

                                loading={loading}

                                onClick={onAccept}

                            >

                                ✅ Accepter l'offre

                            </Button>

                            <Button

                                danger

                                loading={loading}

                                onClick={onDecline}

                            >

                                ❌ Refuser

                            </Button>

                        </Space>

                    </>

                }

            />

        </div>

    );

};

export default AgreementFooter;